function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a03aa2a1-4891-4142-81ef-0ad6e57c905b{fill:#fff;}.bf830614-2b1c-495f-a3c6-78b6c74ca252{fill:#012;stroke:#000;stroke-width:5px;}.b1b7bd81-89c5-426f-bc14-5418cd32c94f,.bf830614-2b1c-495f-a3c6-78b6c74ca252,.ef90416c-c0c6-4eaa-990d-b74a741b1a80{stroke-miterlimit:10;}.b1b7bd81-89c5-426f-bc14-5418cd32c94f{fill:#00ba89;stroke-width:20px;}.b1b7bd81-89c5-426f-bc14-5418cd32c94f,.ef90416c-c0c6-4eaa-990d-b74a741b1a80{stroke:#012;}.ef90416c-c0c6-4eaa-990d-b74a741b1a80{fill:none;stroke-linecap:round;stroke-width:18px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bdd75dbf-2b49-488e-bb94-c842b91df1e9",
  "data-name": "fab238e5-4a98-4e38-b424-c11cc73ee084"
}, /*#__PURE__*/React.createElement("g", {
  id: "b8b48881-0fb8-4179-9be6-6d0632cf34b5",
  "data-name": "b933f69c-3890-4f42-be36-323a7e684247"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a03aa2a1-4891-4142-81ef-0ad6e57c905b",
  x: 116.07,
  y: 182.75,
  width: 296.94,
  height: 272,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "a03aa2a1-4891-4142-81ef-0ad6e57c905b",
  x: 122.69,
  y: 165.75,
  width: 287.32,
  height: 95.36,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "a03aa2a1-4891-4142-81ef-0ad6e57c905b",
  x: 116.07,
  y: 443.86,
  width: 299.75,
  height: 27.17,
  rx: 12
}), /*#__PURE__*/React.createElement("path", {
  className: "bf830614-2b1c-495f-a3c6-78b6c74ca252",
  d: "M269.62,164.41c42.45,0,82.1,4.16,111.33,11.72,17.62,4.54,26.82,9.07,30.84,11.72V450.94c-3.6,2.65-12.81,7.19-30.84,11.72-29.23,7.56-68.88,11.72-111.33,11.72s-82.1-4.16-111.33-11.72c-17.63-4.53-26.82-9.07-30.85-11.72v-263c3.61-2.65,12.82-7.18,30.85-11.72,29.23-7.56,68.87-11.72,111.33-11.72Zm0-15.12c-43.65,0-84.91,4.16-115.74,12.1-29.24,7.56-42.46,16.63-42.46,22.3V455.1c0,5.67,13.22,14.74,42.46,22.3,30.83,7.6,72.12,12.1,115.74,12.1s84.91-4.54,115.74-12.1c29.24-7.56,42.45-16.63,42.45-22.3V183.69c0-5.67-13.21-14.74-42.45-22.3-30.83-7.94-72.09-12.1-115.74-12.1Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b1b7bd81-89c5-426f-bc14-5418cd32c94f",
  d: "M269.94,10C175.83,10,39.35,60.16,34.27,221.11l-9.78,4.61c-18.29,5.26-14,29.53-14.12,48.56L10,327.93v21.46c.14,23.75,39.8,20.1,63.55,20V371a9.76,9.76,0,0,0,9.81,9.69H98.69a9.76,9.76,0,0,0,9.79-9.71h0V225.71h0A9.76,9.76,0,0,0,98.67,216H85.5c6.16-95.85,86.07-159.69,184.44-159.69h-.59c98.37,0,178.28,63.84,184.44,159.69H440.62a9.76,9.76,0,0,0-9.81,9.71h0V371a9.74,9.74,0,0,0,9.77,9.71h15.35a9.76,9.76,0,0,0,9.81-9.69v-1.66c23.75.14,63.4,3.79,63.55-20V327.93l-.38-53.65c-.08-19,4.18-43.3-14.11-48.56l-9.8-4.61C499.94,60.16,363.46,10,269.35,10",
  transform: "translate(0 0)"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "ef90416c-c0c6-4eaa-990d-b74a741b1a80",
  d: "M177.89,257.76c0,22.3,16.58,40.35,37.06,40.35",
  transform: "translate(0 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "ef90416c-c0c6-4eaa-990d-b74a741b1a80",
  d: "M251.62,257.76c0,22.3-16.49,40.35-36.88,40.35",
  transform: "translate(0 0)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "ef90416c-c0c6-4eaa-990d-b74a741b1a80",
  d: "M287.67,257.76c0,22.3,16.57,40.35,37.06,40.35",
  transform: "translate(0 0)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "ef90416c-c0c6-4eaa-990d-b74a741b1a80",
  d: "M361.4,257.76c0,22.3-16.49,40.35-36.88,40.35",
  transform: "translate(0 0)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "ef90416c-c0c6-4eaa-990d-b74a741b1a80",
  cx: 269.64,
  cy: 397.3,
  r: 28.35
});

function SvgLogoOfflineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b2d7df91-38ec-4fcc-9ac7-22ef204a8a6a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 539.29 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfflineIcon);
export default __webpack_public_path__ + "static/media/logo-offline-icon.e2449d5f.svg";
export { ForwardRef as ReactComponent };